export const PROCESSING_MIN_DISPLAY_MS = 3000;

// Report reasons
export const REPORT_TYPE_DISRUPTIVE = 'disruptive';
export const REPORT_TYPE_TRIAL = 'trial';

export const REPORT_TYPES = [REPORT_TYPE_DISRUPTIVE, REPORT_TYPE_TRIAL];
